import '/src/assets/countryFlags.css';
import { Tooltip } from '@chakra-ui/react';
import { getName } from 'country-list';

const CountryFlag = ({ countryCode, title, size, style = {} }) => {
    const upperCountryCode = countryCode?.toUpperCase() || '';

    // (2950) An unknown usage location reads better as nothing at all than as
    // a globe, which implies a location we don't actually have.
    if (!upperCountryCode) {
        return null;
    }

    return (
        <Tooltip label={title || getName(upperCountryCode)}>
            <span
                className={`flag:${upperCountryCode}`}
                style={{
                    display: 'inline-block',
                    width: !size ? '36px' : `${size * 1.5}px`,
                    height: !size ? '24px' : `${size}px`,
                    border: '1px solid gray',
                    ...style,
                }}></span>
        </Tooltip>
    );
};

export default CountryFlag;
